























































































































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import DapProjectInfoPanel from '@/modules/dap/containers/dap-project-info-panel/dap-project-info-panel.vue';
import DapProjectSubmitPanel from '@/modules/dap/containers/dap-project-submit-panel/dap-project-submit-panel.vue';

import { DapSpreadsheetType, DapType, marketShareOperationType } from '@/modules/dap/enums';
import { IProject, IStoreProject, ISubProject } from '@/modules/dap/interfaces';
import { Project, SubProject } from '@/modules/dap/models';
import { DapSpreadsheetFactory } from '@/modules/dap/services/dap-spreadsheet.factory';
import { dateService, httpService, stringService } from '@/services';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';
import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { NOTIFICATIONS_GET } from '@/store/modules/notifications/types';

@Component({
  subscriptions() {
    return {
      searchValue$: this.$watchAsObservable('searchValue').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    DapProjectInfoPanel,
    DapProjectSubmitPanel
  }
})
export default class DapProjectIdPage extends Vue {
  @Prop()
  public projectId: number;

  @Getter(AUTH_GET_USERNAME)
  public userName: string;

  @Getter(AUTH_GET_TOKEN)
  public userToken: string;

  @Getter(NOTIFICATIONS_GET)
  public notification: any;

  public DapType = DapType;
  public parseDateToString = dateService.parseDateToString;
  public parseToMoment = dateService.parseToMoment;

  public currentPage: number = 1;
  public searchValue: string = '';
  public sendForApproval: boolean = false;
  public searchValue$: string;
  public productsType: any = {};
  public segmentsType: any = {};
  public referenceMktShareType: any[] = [];
  public marketLevelDataSource: any[] = [];
  public productsDataSource: any[] = [];
  public segmentsDataSource: any[] = [];
  public aovs: any[] = [];
  public selectedSubProjectType = String(DapType.All);
  public subProjectColumnOrder = 'createdAt';
  public subProjects: any[] = [];
  public subProject: ISubProject = new SubProject();
  public project: IProject = new Project();

  public infoPanel: any = {
    visible: false,
    projectId: 0,
    dapId: 0
  };

  public subProjectColumnOrderDataSource = [
    {
      text: 'Nome',
      value: 'name'
    },
    {
      text: 'Família',
      value: 'idFamilyGroup'
    },
    {
      text: 'Segmento',
      value: 'idSegmentGroup'
    },
    {
      text: 'Data de Criação',
      value: 'createdAt'
    }
  ];

  public get subProjectsView() {
    return _(this.subProjects)
      .filter((p: ISubProject) => {
        switch (+this.selectedSubProjectType) {
          case DapType.Simple:
            return p.dapMethodologyType === DapType.Simple;
          case DapType.Composed:
            return p.dapMethodologyType === DapType.Composed;
          default:
            return true;
        }
      })
      .filter(
        (p: ISubProject) =>
          _.size(this.searchValue$)
            ? stringService.normalize(p.name).includes(stringService.normalize(this.searchValue$))
            : true
      )
      .orderBy((p: ISubProject) => {
        switch (this.subProjectColumnOrder) {
          case 'idFamilyGroup':
            return this.productsType[p.idFamilyGroup];
          case 'idSegmentGroup':
            return this.segmentsType[p.idSegmentGroup];
          case 'createdAt':
            return -new Date(p.createdAt);
          default:
            return p.name;
        }
      })
      .value();
  }

  public get storesTypes(): any {
    return _(this.project.storeProjects)
      .groupBy('typeName')
      .map((stores: IStoreProject[], type: string) => ({
        name: type,
        total: stores.length
      }))
      .value();
  }

  public get saleTargets() {
    return this.subProject
      ? this.subProject.saleTargets.length > 0
        ? this.subProject.saleTargets
        : _.map(_.range(0, this.project.qtdMonths), (i: number) => ({
            value: 0,
            monthReference: i + 1
          }))
      : [];
  }

  public get canConsolidate(): boolean {
    return this.subProjects.filter((p: ISubProject) => Boolean(p.isSelected)).length > 0;
  }

  public created() {
    return this.loadParameters();
  }

  @Watch('notification')
  public updateProjectStatus(message: any) {
    if (message.data && message.data.project && message.data.project.id === this.project.id) {
      this.project.rapStatus = 1;
    }
  }

  @Watch('projectId')
  public async loadParameters() {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/families`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/segments`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/mktShareReferenceTypes`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/aovs`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/pure`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/composed`)
    ];

    return Promise.all(req)
      .then((res: Array<AxiosResponse>) => {
        this.productsType = res[0].data.reduce((acc: any, val: any) => {
          acc[val.value] = val.text;
          return acc;
        }, {});

        this.segmentsType = res[1].data.reduce((acc: any, val: any) => {
          acc[val.value] = val.text;
          return acc;
        }, {});

        this.productsDataSource = res[0].data;
        this.segmentsDataSource = res[1].data;
        this.referenceMktShareType = _.map(res[2].data, (d: any) => ({ text: d.name, value: d.id }));
        this.marketLevelDataSource = _.reduce(res[2].data, (acc, val: any) => acc.concat(val.marketShareRefences), []);
        this.aovs = res[3].data;

        if (res[4].data) {
          this.project = res[4].data;
        }

        _.forEach(res[5].data, (d: any) => {
          d.dapMethodologyType = DapType.Simple;
        });

        _.forEach(res[6].data, (d: any) => {
          d.dapMethodologyType = DapType.Composed;
        });

        this.subProjects = [...res[5].data, ...res[6].data];
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public editDap(id: number) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_CONFIGURATION_EDIT,
      params: {
        projectId: String(this.projectId),
        dapId: String(id)
      },
      query: {
        wizardStep: '3'
      }
    });
  }

  public selectDap(subProject: ISubProject) {
    _(this.subProjects)
      .filter((s: ISubProject) => s.idFamilyGroup === subProject.idFamilyGroup)
      .filter((s: ISubProject) => s.id !== subProject.id)
      .forEach((s: ISubProject) => (s.isSelected = false));
  }

  public showInfoPanel(dapId: number) {
    this.infoPanel = _.assign({}, this.infoPanel, {
      visible: true,
      projectId: this.projectId,
      dapId
    });
  }

  public saveAsPDF(idAov: number) {
    const filters = JSON.stringify({
      projectId: this.projectId,
      idAov
    });

    // console.log(`${CONFIG.URL.HOST}/report/rap/printing?dialog=1&reports=["rap"]&filters=${filters}&user=${this.userName}&apikey=${this.userToken}`);
    window.open(
      `${CONFIG.URL.HOST}/report/rap/printing?dialog=1&reports=["rap"]&filters=${filters}&user=${
        this.userName
      }&apikey=${this.userToken}`
    );
  }

  public consolidateDap() {
    const data = this.subProjects.filter((p: ISubProject) => Boolean(p.isSelected)).map((p: ISubProject) => p.id);
    const req = [
      httpService.http.post(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/consolidateProject`, data)
    ];

    this.project.rapStatus = 2;

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this._normalizeResponse(res);

        const dapConsolidated = DapSpreadsheetFactory.get(DapSpreadsheetType.Consolidated, res[0].data);
        dapConsolidated.name = `${dapConsolidated.name}_${stringService.normalize(this.project.name)}`;
        dapConsolidated.create().saveAsExcel();
      })
      .catch((res: AxiosError) => {
        console.log(res);
      });
  }

  public getConsolidateDap() {
    const data = this.subProjects.filter((p: ISubProject) => Boolean(p.isSelected)).map((p: ISubProject) => p.id);
    const req = [
      httpService.http.post(
        `${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/retrieve/consolidateProject`,
        data
      )
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this._normalizeResponse(res);
        const dapConsolidated = DapSpreadsheetFactory.get(DapSpreadsheetType.Consolidated, res[0].data);
        dapConsolidated.name = `${dapConsolidated.name}_${stringService.normalize(this.project.name)}`;
        dapConsolidated.create().saveAsExcel();
      })
      .catch((res: AxiosError) => {
        console.log(res);
      });
  }

  public submitForApproval() {
    this.sendForApproval = true;
  }

  public saveAsExcel(dapId: number, type: number) {
    const influenceSubProjects = _(this.subProjects)
      .filter((s: ISubProject) => s.id === dapId)
      .map((s: ISubProject) => s.cfgMtdPlanInfluences)
      .flatten()
      .value();

    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/info`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${dapId}/config`)
    ];

    if (type === DapType.Simple) {
      req.push(
        httpService.http.get(
          `${CONFIG.URL.NEODASH_API}/api/dap/project/${
            this.projectId
          }/subProject/${dapId}/output/marketShareInfluence`
        )
      );
      req.push(
        httpService.http.get(
          `${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${dapId}/output/segmentInfluence`
        )
      );
    } else {
      req.push(
        httpService.http.get(
          `${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${dapId}/output/planInfluence`
        )
      );
      req.push(
        ..._.map(influenceSubProjects, (s: any) =>
          httpService.http.get(
            `${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${
              s.idSubProjectTarget
            }/output/marketShareInfluence`
          )
        )
      );
      req.push(
        ..._.map(influenceSubProjects, (s: any) =>
          httpService.http.get(
            `${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${
              s.idSubProjectTarget
            }/output/segmentInfluence`
          )
        )
      );
    }

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        const infoDataSource: any = this._createInfoPanelDataSource(res);

        this._normalizeResponse(res);

        if (type === DapType.Simple) {
          DapSpreadsheetFactory.get(DapSpreadsheetType.MarketShareAndSegmentInfluence, [
            infoDataSource,
            res[0].data,
            res[1].data,
            this._createSumByAovDataSource(res[0].data),
            this._createSumByMarkedAreaDataSource(res[0].data)
          ])
            .create()
            .saveAsExcel();
        } else {
          const influencePlan = res.splice(0, 1).map((d: any) => d.data);
          const marketShareInfluence = res.splice(0, influenceSubProjects.length).map((d: any) => d.data);
          const segmentInfluence = res.splice(0, influenceSubProjects.length).map((d: any) => d.data);
          const sumByAov = marketShareInfluence.map((d: any) => this._createSumByAovDataSource(d));
          const sumByMarkedArea = marketShareInfluence.map((d: any) => this._createSumByMarkedAreaDataSource(d));
          DapSpreadsheetFactory.get(DapSpreadsheetType.AllMethodology, [
            infoDataSource,
            influencePlan,
            marketShareInfluence,
            segmentInfluence,
            sumByAov,
            sumByMarkedArea
          ])
            .create()
            .saveAsExcel();
        }
      })
      .catch((res: AxiosError) => {
        console.log(res);
      });
  }

  private _createSumByAovDataSource(data: any[]) {
    return _(data)
      .filter((d: any) => d.aov)
      .groupBy((d: any) => d.aov)
      .map((d: any, name: string) => ({
        aov: name,
        familyName: d[0].familyName,
        industryRetailRegistration: _(d)
          .uniqBy('markedAreaName')
          .sumBy('industryRetailRegistration'),
        industryRegistrationInSegment: _(d)
          .uniqBy('markedAreaName')
          .sumBy('industryRegistrationInSegment'),
        percentSegmentInIndustryRetail:
          _(d)
            .uniqBy('markedAreaName')
            .sumBy('industryRegistrationInSegment') /
          _(d)
            .uniqBy('markedAreaName')
            .sumBy('industryRetailRegistration'),
        clientRetailRegistrationInSegment: _(d)
          .uniqBy('markedAreaName')
          .sumBy('clientRetailRegistrationInSegment'),
        clientMarketShareInSegment:
          _(d)
            .uniqBy('markedAreaName')
            .sumBy('clientRetailRegistrationInSegment') /
          _(d)
            .uniqBy('markedAreaName')
            .sumBy('industryRegistrationInSegment'),
        productSales3s: _(d)
          .filter((s: any) => s.storeType.toUpperCase() === '3S')
          .sumBy('productSales'),
        productSales2s: _(d)
          .filter((s: any) => s.storeType.toUpperCase() === '2S')
          .sumBy('salesInSegment'),
        initialHistoryPeriod: d[0].initialHistoryPeriod,
        finalHistoryPeriod: d[0].finalHistoryPeriod,
        dapValuesFound: d[0].dapValuesFound.map((item: any, idx: number) => {
          const dapValuesFound: any = { ...item };
          dapValuesFound.value = _.sumBy(d, (s: any) => s.dapValuesFound[idx].value);
          return dapValuesFound;
        }),
        dapMarketShareForecast: d[0].dapValuesForecast.map((item: any, idx: number) => {
          let result = this._calculateMarketShareForecast(
            d[0].initialHistoryPeriod,
            d[0].finalHistoryPeriod,
            _(d)
              .uniqBy('markedAreaName')
              .sumBy('industryRegistrationInSegment'),
            _(d)
              .uniqBy('markedAreaName')
              .sumBy('clientRetailRegistrationInSegment'),
            _(d)
              .filter((s: any) => s.storeType.toUpperCase() === '3S')
              .sumBy('productSales'),
            _.sumBy(d, (s: any) => s.dapValuesFound[idx].value)
          );

          return { ...item, value: result };
        })
      }))
      .orderBy((d: any) => d.aov)
      .value() as any[];
  }

  private _calculateMarketShareForecast(
    initialDate,
    finalDate,
    industryRegistration,
    clientRegistration,
    sales,
    salesGoal
  ) {
    var months = this._qtdMonthsBetweenDate(initialDate, finalDate);
    var gap = this._calculateGap(months, sales, salesGoal);

    return (clientRegistration + gap) / (industryRegistration + gap);
  }

  private _calculateGap(qtdMonths, sales, salesGoal) {
    return salesGoal * qtdMonths - sales;
  }

  private _qtdMonthsBetweenDate(startDate, endDate) {
    return moment(endDate).diff(moment(startDate), 'months', true) + 1;
  }

  private _createSumByMarkedAreaDataSource(data: any[]) {
    return _(data)
      .filter((d: any) => d.markedAreaName)
      .groupBy((d: any) => d.markedAreaName)
      .map((d: any, name: string) => ({
        markedAreaName: name,
        aov: d[0].aov,
        familyName: d[0].familyName,
        industryRetailRegistration: d[0].industryRetailRegistration,
        industryRegistrationInSegment: d[0].industryRegistrationInSegment,
        percentSegmentInIndustryRetail: d[0].industryRegistrationInSegment / d[0].industryRetailRegistration,
        clientRetailRegistrationInSegment: d[0].clientRetailRegistrationInSegment,
        clientMarketShareInSegment: d[0].clientRetailRegistrationInSegment / d[0].industryRegistrationInSegment,
        productSales3s: _(d)
          .filter((s: any) => s.storeType.toUpperCase() === '3S')
          .sumBy('productSales'),
        productSales2s: _(d)
          .filter((s: any) => s.storeType.toUpperCase() === '2S')
          .sumBy('salesInSegment'),
        initialHistoryPeriod: d[0].initialHistoryPeriod,
        finalHistoryPeriod: d[0].finalHistoryPeriod,
        dapValuesFound: d[0].dapValuesFound.map((item: any, idx: number) => {
          const dapValuesFound: any = { ...item };
          dapValuesFound.value = _.sumBy(d, (s: any) => s.dapValuesFound[idx].value);
          return dapValuesFound;
        }),
        dapMarketShareForecast: d[0].dapValuesForecast.map((item: any, idx: number) => {
          const dapValuesForecast: any = { ...item };
          dapValuesForecast.value = item.value;
          return dapValuesForecast;
        })
      }))
      .orderBy((d: any) => d.markedAreaName)
      .orderBy((d: any) => d.aov)
      .value() as any[];
  }

  private _createInfoPanelDataSource(res: AxiosResponse[]) {
    const project = res.splice(0, 1)[0].data;
    const subProject = res.splice(0, 1)[0].data;

    this.project = _.assign({}, this.project, {
      projectMktShareReferenceDefaults: project.projectMktShareReferenceDefaults
    });
    this.subProject = _.assign({}, this.subProject, subProject);
    this.subProject.idMarketShareReferenceType = this.project.idMarketShareReferenceType as any;

    this._createSubProjectLimits();
    this._createSaleTargets();

    return {
      name: subProject.name,
      initialHistoryPeriod: new Date(subProject.initialHistoryPeriod),
      finalHistoryPeriod: new Date(subProject.finalHistoryPeriod),
      familyName: this.productsType[subProject.idFamilyGroup],
      segmentName: this.segmentsType[subProject.idSegmentGroup],
      saleTargets: _(subProject.saleTargets)
        .map((d: any) => {
          d.monthName = (moment.localeData() as any)._monthsShort[d.monthReference];
          return d;
        })
        .orderBy((d: any) => d.monthReference)
        .orderBy((d: any) => d.yearReference)
        .value(),
      subProjectLimits: _.map(this.subProject.subProjectLimits, (d: any) => ({
        name: d.name,
        limitPercentInferior: d.limitPercentInferior,
        limitPercentSuperior: d.limitPercentSuperior,
        marketShareInferior: d.marketShareInferior,
        marketShareMedium: d.marketShareMedium,
        marketShareSuperior: d.marketShareSuperior
      })),
      marketShareInfluence: _.reduce(
        this.subProject.subProjectLimits,
        (acc: any[], d: any) => {
          if (d.cfgMtdMarketShareInfluenceDto) {
            const doc: any = {
              name: d.name
            };

            doc.roleLimitSuperior = marketShareOperationType[d.cfgMtdMarketShareInfluenceDto.roleLimitSuperior];
            doc.percentIncreaseLimitSuperior = d.cfgMtdMarketShareInfluenceDto.percentIncreaseLimitSuperior;
            doc.roleLimitMedium = marketShareOperationType[d.cfgMtdMarketShareInfluenceDto.roleLimitMedium];
            doc.percentIncreaseLimitMedium = d.cfgMtdMarketShareInfluenceDto.percentIncreaseLimitMedium;
            doc.roleLimitMediumInferior =
              marketShareOperationType[d.cfgMtdMarketShareInfluenceDto.roleLimitMediumInferior];
            doc.percentIncreaseLimitMediumInferior = d.cfgMtdMarketShareInfluenceDto.percentIncreaseLimitMediumInferior;
            doc.roleLimitInferior = marketShareOperationType[d.cfgMtdMarketShareInfluenceDto.roleLimitInferior];
            doc.percentIncreaseLimitInferior = d.cfgMtdMarketShareInfluenceDto.percentIncreaseLimitInferior;

            acc.push(doc);
          }
          return acc;
        },
        []
      ),
      segmentsInfluence: _.reduce(
        this.subProject.subProjectLimits,
        (acc: any[], d: any) => {
          const doc: any = {
            name: d.name
          };

          _.forEach(d.cfgMtdSegmentInfluencesDto, (c: any) => {
            acc.push(
              _.assign({}, doc, {
                text: this.productsType[c.idFamilyGroup],
                value: c.valuePercent
              })
            );
          });

          return acc;
        },
        []
      ),
      planInfluence: subProject.cfgMtdPlanInfluences.map((d: any) => {
        d.projectName = this.subProjects.find((s: ISubProject) => s.id === d.idSubProjectTarget).name;
        return d;
      }),
      industryProjection: subProject.cfgIndustryProjection
    };
  }

  private _createSubProjectLimits() {
    if (!this.subProject) {
      return;
    }

    this.subProject.subProjectLimits = _(this.marketLevelDataSource)
      .filter((d: any) => d.idType === this.subProject.idMarketShareReferenceType)
      .map((d: any) =>
        _.assign(
          {},
          d,
          { name: d.name },
          (_.find(this.subProject.subProjectLimits, (ml: any) => ml.idMarketShareReference === d.idType) as any) || {}
        )
      )
      .value();
  }

  private _createSaleTargets() {
    if (!this.subProject) {
      return;
    }

    this.subProject.saleTargets = _(this.saleTargets)
      .map((d: any, i: number) => ({
        value: d.value,
        monthNumber: i + 1,
        monthReference: Number(
          dateService
            .parseToMoment(this.subProject ? this.subProject.initialDateProject : new Date())
            .add(i, 'months')
            .format('MM')
        ),
        monthName: dateService
          .parseToMoment(this.subProject ? this.subProject.initialDateProject : new Date())
          .add(i, 'months')
          .format('MMM'),
        yearReference: Number(
          dateService
            .parseToMoment(this.subProject ? this.subProject.initialDateProject : new Date())
            .add(i, 'months')
            .format('YYYY')
        ),
        shortYear: Number(
          dateService
            .parseToMoment(this.subProject ? this.subProject.initialDateProject : new Date())
            .add(i, 'months')
            .format('YY')
        )
      }))
      .value();
  }

  private _normalizeResponse(res: AxiosResponse[]) {
    const familyName = _.find(res[0].data, (d: any) => d.familyName).familyName;

    _.forEach(res, (r: AxiosResponse) => {
      r.data = _(r.data)
        .map((d: any) => {
          if (!d.familyName) {
            d.familyName = familyName;
          }

          if (d.updatedAt) {
            d.updatedAt = new Date(d.updatedAt);
          }

          if (d.dateConversion) {
            d.dateConversion = new Date(d.dateConversion);
          }

          d.initialHistoryPeriod = d.initialHistoryPeriod
            ? new Date(d.initialHistoryPeriod)
            : new Date(this.project.initialHistoryPeriod);

          d.finalHistoryPeriod = d.finalHistoryPeriod
            ? new Date(d.finalHistoryPeriod)
            : new Date(this.project.finalHistoryPeriod);

          _.forEach(['dapValuesFound', 'dapValuesFoundCombined', 'dapValuesFoundNormalized'], (key: string) => {
            if (_.size(d[key])) {
              d[key] = _(d[key])
                .orderBy((v: any) => v.month)
                .orderBy((v: any) => v.year)
                .value();
            }
          });

          return d;
        })
        .orderBy((d: any) => (+d.dealerNumber ? +d.dealerNumber : 999999999))
        .orderBy((d: any) => (+d.dealerNumberMatrix ? +d.dealerNumberMatrix : 999999999))
        .value();
    });

    return res;
  }
}
